import { EntityTypeEnum } from "@app/projects/enumerators";
import generateDefaultProviderPanelRow from "./defaultProviderPanelRow";
import InspectionProfileTableData from "./inspectionProfileTableData";
import { valueOrDashes } from "./utils";
import { AccuracyProviderDetail } from "@app/projects/results/accuracy/accuracyProviderDetail";

export let isOrganizationEntity = false;

/* oxlint-disable sort-keys */
export const generateEntityTypeProviderPanelRow = (rowKey: string, title: string, sourceRecord: AccuracyProviderDetail): InspectionProfileTableData => {
  const entityTypeData = generateDefaultProviderPanelRow(rowKey, title, convertEntityTypeString(sourceRecord.entityType), sourceRecord.inspectionSupplement.entityType);
  entityTypeData.source = valueOrDashes((sourceRecord.entityType && sourceRecord.entityType.toLowerCase() !== "unknown") ? convertEntityTypeString(sourceRecord.entityType) : null);
  return entityTypeData;
}


const convertEntityTypeString = (entityType: string): string => {
  if (entityType.toLowerCase() === EntityTypeEnum.Facility.toLowerCase()) {
    isOrganizationEntity = true;
    return "Organization";
  }
  return entityType
  }